import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { ChakraOrnament } from './ChakraOrnament';
import { Mandala } from './HealingIcons';
import { Pricing } from './Pricing';
import { Section } from './Shared';
type Tomo = {
  number: string;
  title: string;
  subtitle: string;
  description: string;
  coverUrl: string;
};
type Bonus = {
  number: string;
  title: string;
  description: string;
  price: string;
  coverUrl: string;
};
const tomos: Tomo[] = [{
  number: 'Tomo 1',
  title: 'El Sistema Operativo del Terapeuta Reiki™',
  subtitle: 'El manual de gestión profesional',
  description: 'Dominá el Reloj Maestro™, la preparación, entrevista inicial y arquitectura de una sesión de excelencia.',
  coverUrl: 'https://cdn.magicpatterns.com/uploads/kbRMuSZDuGe5RNdXsKZkjK/Portada_tomo_1.png'
}, {
  number: 'Tomo 2',
  title: 'Manual de Sesiones Prediseñadas Reiki™',
  subtitle: 'Tu guía técnica definitiva',
  description: '20 protocolos para ansiedad, insomnio, duelo, estrés, dolores físicos y más. Nunca más improvises.',
  coverUrl: 'https://cdn.magicpatterns.com/uploads/krQCaMgAgfsxQr1Wt5DJPX/portada_tomo_2_reiki.png'
}, {
  number: 'Tomo 3',
  title: 'Planificador Profesional del Terapeuta Reiki™',
  subtitle: 'La herramienta de crecimiento',
  description: 'Organizá agenda, finanzas, objetivos y el balance de tu consultorio con una visión sostenible.',
  coverUrl: 'https://cdn.magicpatterns.com/uploads/jKrWswSkQGRhggheP1NAnB/Portada_tomo_3.png'
}];
const bonuses: Bonus[] = [{
  number: '01',
  title: 'Diario del Terapeuta Reiki™',
  description: 'Reflexión, aprendizaje y evolución profesional.',
  price: '$12.000',
  coverUrl: 'https://cdn.magicpatterns.com/uploads/jL35raqRXRdxT7euURmMKd/Portada_bono_1.png'
}, {
  number: '02',
  title: 'Fichas Profesionales del Paciente',
  description: 'El registro que transforma sesiones en procesos reales.',
  price: '$12.000',
  coverUrl: 'https://cdn.magicpatterns.com/uploads/8JCtt8icbwQLrGQvX4sZDL/portada_bono_2.png'
}, {
  number: '03',
  title: 'Checklist de Apertura y Cierre',
  description: 'Ningún detalle profesional queda librado al azar.',
  price: '$10.000',
  coverUrl: 'https://cdn.magicpatterns.com/uploads/nWkApd6wKvvpE2vD6vKKpw/portada_bono_3.png'
}, {
  number: '04',
  title: 'Cuaderno de Seguimiento',
  description: 'Convertí sesiones aisladas en procesos sostenidos.',
  price: '$12.000',
  coverUrl: 'https://cdn.magicpatterns.com/uploads/frrxeQ6U1xXhQpTVugdS8V/Portada_bono_4.png'
}, {
  number: '05',
  title: 'Protocolos Rápidos de Consulta',
  description: 'Tu guía inmediata antes de cada sesión.',
  price: '$10.000',
  coverUrl: 'https://cdn.magicpatterns.com/uploads/265oTntkWfLcd1peLqKsLx/Portada_bono_5.png'
}, {
  number: '06',
  title: 'Kit de Plantillas Imprimibles',
  description: 'Documentos que formalizan tu consulta desde el inicio.',
  price: '$10.000',
  coverUrl: 'https://cdn.magicpatterns.com/uploads/v1okXtKd3qKRSfvuaFUvEf/Portada_bono_6.png'
}];
export function PackContents() {
  return <Section id="method" className="relative" data-id="element-198" data-mp="286ue4y6so1tw">
      <Mandala className="absolute -left-16 top-16 -z-10 h-56 w-56 opacity-10" color="#76557C" data-id="element-199" data-mp="2d4mbi7q7kg5h" />
      <ChakraOrnament className="absolute right-8 top-20 -z-10 hidden h-44 opacity-35 xl:block" data-id="element-200" data-mp="1yfpw1plto0uu" />
      <div className="mx-auto max-w-5xl text-center" data-id="element-201" data-mp="23et1hb5ps93c">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-brand-gold/55 bg-brand-paper px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-brand-purple shadow-sm" data-id="element-202" data-mp="23d883ov4yw72">
          <BookOpenIcon className="h-3.5 w-3.5 text-brand-goldDark" aria-hidden="true" data-id="element-203" data-mp="1ufpie76jrtou" />
          Presentando el MEGA PACK REIKI™
        </span>
        <h2 className="mt-3 font-display text-[30px] font-bold leading-[0.9] text-brand-ink sm:text-4xl md:text-5xl" data-id="element-204" data-mp="1kfovycddsxgf">
          Todo lo que necesitás para ejercer Reiki con más{' '}
          <span className="relative z-0 inline-block px-1.5 text-brand-purpleDark before:absolute before:inset-x-0 before:bottom-[0.06em] before:-z-10 before:h-[0.42em] before:-rotate-1 before:rounded-sm before:bg-brand-goldLight/90" data-id="element-205" data-mp="39t26wkg01jqi">
            orden, confianza y profesionalismo.
          </span>
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-5" data-id="element-206" data-mp="15qioldhsuepj">
        {tomos.map(tomo => <TomoCard key={tomo.number} tomo={tomo} data-id="element-207" data-mp="10sqkzm7sl45i" />)}
      </div>

      <div className="mt-12 text-center" data-id="element-208" data-mp="vsugllv6napf">
        <h3 className="flex items-center justify-center gap-2 font-serif text-2xl font-bold text-brand-ink" data-id="element-209" data-mp="vtw3cnlk9lmz">
          <GiftIcon className="h-5 w-5 text-brand-goldDark" aria-hidden="true" data-id="element-210" data-mp="r1chz4gmtm7m" />
          6 BONOS ESTRATÉGICOS — <span className="text-brand-greenDark" data-id="element-211" data-mp="n12afnd6ynqn">GRATIS</span>
        </h3>
      </div>
      <div className="mx-auto mt-7 grid max-w-6xl grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-212" data-mp="i2iqttm2lo1g">
        {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-213" data-mp="d1l6badl8hws" />)}
      </div>
      <div className="mt-7 text-center" data-id="element-214" data-mp="84b938jyj1ye">
        <span className="inline-block rounded-full border border-brand-gold/50 bg-brand-paper px-5 py-3 text-sm font-medium text-brand-text" data-id="element-215" data-mp="85cx0dm2nixj">
          Valor total bonos <span className="text-brand-muted line-through" data-id="element-216" data-mp="2xel4hw3lw50">$66.000</span>{' '}
          <strong className="text-brand-forest" data-id="element-217" data-mp="7wzkgtf6k6i9">→ GRATIS con tu MEGA PACK REIKI™</strong>
        </span>
      </div>
    </Section>;
}
export function MethodOverview() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-218" data-mp="cu9g4qt5xeej">
      <Pricing data-id="element-219" data-mp="3bfsvozkhkj99" />
    </div>;
}
function TomoCard({
  tomo
}: {
  tomo: Tomo;
}) {
  return <article className="overflow-hidden rounded-2xl border border-brand-purple/20 bg-brand-paper p-3 text-left shadow-[0_10px_24px_rgba(76,50,79,0.08)] sm:p-4" data-id="element-220" data-mp="3gedtytg6gsv2">
      <div className="grid grid-cols-[5.5rem_1fr] gap-3 sm:grid-cols-1 sm:gap-3" data-id="element-221" data-mp="3q2vqgyhfcdsw">
        <div className="aspect-[2/3] overflow-hidden rounded-lg border border-brand-gold/35 bg-brand-surfaceLight/40 sm:mx-auto sm:w-full" data-id="element-222" data-mp="3q4ys6frxvvdg">
          <img src={tomo.coverUrl} alt={`Portada ${tomo.number}: ${tomo.title}`} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-223" data-mp="2xm1hvezq2d7q" />
        </div>
        <div className="min-w-0" data-id="element-224" data-mp="2kn22iutoikq8">
          <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-brand-purple" data-id="element-225" data-mp="2km0s8skhm29k">{tomo.number}</span>
          <h3 className="mt-1 font-serif text-base font-bold leading-[1.02] text-brand-ink sm:text-lg" data-id="element-226" data-mp="2zan8cwhxuy1u">{tomo.title}</h3>
          <p className="mt-2 text-[11px] font-semibold leading-snug text-brand-forest" data-id="element-227" data-mp="2udn9b5jiavk8">{tomo.subtitle}</p>
          <p className="mt-1.5 text-[11px] leading-snug text-brand-muted" data-id="element-228" data-mp="26pdkduqzxrov">{tomo.description}</p>
        </div>
      </div>
    </article>;
}
function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="relative overflow-hidden rounded-2xl border border-brand-purple/20 bg-brand-paper p-3 shadow-[0_8px_20px_rgba(76,50,79,0.06)] sm:p-4" data-id="element-229" data-mp="2gms0ft90cegn">
      <div className="grid grid-cols-[4.5rem_1fr] gap-3" data-id="element-230" data-mp="3rzucqc42qhv0">
        <div className="relative aspect-[2/3] overflow-hidden rounded-lg border border-brand-gold/35 bg-brand-surfaceLight/40" data-id="element-231" data-mp="3s2gji9j54tc6">
          <img src={bonus.coverUrl} alt={`Portada del bono ${bonus.number}: ${bonus.title}`} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-232" data-mp="3ukil43pi7suk" />
          <span className="absolute bottom-1 left-1 rounded-full bg-brand-greenDark px-1.5 py-0.5 text-[7px] font-bold tracking-[0.08em] text-white" data-id="element-233" data-mp="3ceaokihxtrj">GRATIS</span>
        </div>
        <div className="relative min-w-0 py-0.5" data-id="element-234" data-mp="3pm8so0v5z6cn">
          <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-brand-purple" data-id="element-235" data-mp="h5nfs8zevt49">BONO {bonus.number}</span>
          <h4 className="mt-1 font-serif text-[15px] font-bold leading-[1.05] text-brand-ink" data-id="element-236" data-mp="m473adtnlcyq">{bonus.title}</h4>
          <p className="mt-1.5 text-[11px] leading-snug text-brand-muted" data-id="element-237" data-mp="8d275lphv2t5">{bonus.description}</p>
          <p className="mt-2 text-[10px] font-medium text-brand-muted" data-id="element-238" data-mp="ce49ibepjuzc"><span className="line-through" data-id="element-239" data-mp="1059pqrok8pa6">Valor {bonus.price}</span> <strong className="ml-1 text-brand-greenDark" data-id="element-240" data-mp="103qb15ijymai">→ GRATIS</strong></p>
        </div>
      </div>
    </article>;
}